export const isProduction = (): boolean => {
	return process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
};

export const isDevelopment = (): boolean => {
	return process.env.NEXT_PUBLIC_VERCEL_ENV === 'development';
};
